<script setup lang="ts">
import { ref,reactive,onMounted,onBeforeUnmount,toRefs,watch } from 'vue'
import ModalDialog from "../../compositions/ModalDialog.vue";
import PharmacyTagComponent from "./PharmacyTagComponent.vue";
import config from "../../config.js";
import { errorAlert,confirmAlert } from "../../plugins/alert";
import { getFieldValue,configKeyFromValue,deepCopy } from "../../plugins/utility";
import qs from 'qs';
import axios from '../../plugins/axios.ts';

const props = defineProps({
    tags:{
      type:Array,
      required:true,
    },
    apis:{
      type:Object,
      required:true,
    },
    pharmacyMedicineId:{
      type:Number,
      required:true,
    },
    identityId:{
      type:Number,
      default:() => {
        return 0;
      },
    },
    isEdit:{
      type:Boolean,
      default:() => {
        return true;
      },
    },
    submit:{
      type:Function,
    },
    cancel:{
      type:Function,
    },
});
const { tags } = toRefs(props);
const pharmacyTagRef = ref();
const isLoading = ref(false);
const pharmacyTagIdentityId = ref(0);
const pharmacyMedicineTags = reactive(props.tags);
const isPharmacyMedicineTagDialog = ref(false);
const pharmacyMedicineTagIdentityId = ref(0);
const pharmacyTagCheckList = reactive([]);
const showPharmacyMedicineTagDialog = () => {
  pharmacyTagRef.value.getPharmacyTags();
  pharmacyTagCheckList.splice(0);
  for (let i=0;i<pharmacyMedicineTags.length;i++) {
    pharmacyTagCheckList.push(pharmacyMedicineTags[i]['pharmacy_tag_id']);
  }
  pharmacyMedicineTagIdentityId.value++;
  isPharmacyMedicineTagDialog.value = true;
}
const closePharmacyMedicineTagDialog = () => {
  isPharmacyMedicineTagDialog.value = false;
  if (typeof props.cancel !== 'undefined') {
    props.cancel();
  }
}
watch(tags,(newValue,oldValue) => {
  pharmacyMedicineTags.splice(0);
  for (let i=0;i<newValue.length;i++) {
    pharmacyMedicineTags.push(newValue[i]);
  }
},{deep:true});

onMounted(() => {
  //採用品の表示数だけ埋め込まれるのでここにAPI処理を入れないこと
})
onBeforeUnmount(() => {
})
const updatePharmacyMedicineTag = async () => {
  isLoading.value = true;
  try {
    let params = {
      pharmacy_medicine_id:props.pharmacyMedicineId,
      update_list:[],
      delete_list:[]
    };
    for (let i=0;i<pharmacyMedicineTags.length;i++) {
      if (pharmacyTagCheckList.includes(pharmacyMedicineTags[i]['pharmacy_tag_id']) == false) {
        params['delete_list'].push(pharmacyMedicineTags[i]['id']);
      }
    }
    for (let i=0;i<pharmacyTagCheckList.length;i++) {
      let exists = false;
      for (let j=0;j<pharmacyMedicineTags.length;j++) {
        if (pharmacyMedicineTags[j]['pharmacy_tag_id'] == pharmacyTagCheckList[i]) {
          exists = true;
          break;
        }
      }
      if (exists == false) {
        params['update_list'].push({
          pharmacy_medicine_id:props.pharmacyMedicineId,
          pharmacy_tag_id:pharmacyTagCheckList[i]
        });
      }
    }
    const response = await axios(props.apis.pharmacy_medicine_tag_update,{method:"post",data:params});
    if (response.data.status == 200) {
      if (typeof props.submit !== 'undefined') {
        props.submit(props.pharmacyMedicineId,response.data.data);
      }
      closePharmacyMedicineTagDialog();
    }
  } finally {
    isLoading.value = false;
  }
}
const onChangePharmacyTagCheck = (tags) => {
  pharmacyTagCheckList.splice(0);
  for (let i=0;i<tags.length;i++) {
    pharmacyTagCheckList.push(tags[i]);
  }
}
</script>

<style scoped>
</style>
<template>
<div>
  <div v-show="isLoading" class="loading-mask">
    <div class="loading-content">
      <span style="color: white"><img src="../../../public/images/loading.gif"></span>
    </div>
  </div>
  <span v-if="isEdit" class="ml-1 text-lg cursor-pointer" @click="showPharmacyMedicineTagDialog"><i class="fa-solid fa-tag"></i></span><span class="medicine-tag" v-for="tagData in pharmacyMedicineTags" :key="tagData.id" :style="'background-color:' + tagData.background_color + ';border: 1px solid ' + tagData.border_color + ';color:' + tagData.color"><i class="fa-solid fa-tag"></i> {{ tagData.tag_name }}</span>
</div>
<modal-dialog
  :is-visible="isPharmacyMedicineTagDialog"
  width="20%"
  :close="closePharmacyMedicineTagDialog"
>
  <template v-slot:header>
    タグ設定
  </template>
  <template v-slot:default>
    <div class="w-full">
      <pharmacy-tag-component
        ref="pharmacyTagRef"
        :apis="apis"
        :identity-id="pharmacyTagIdentityId"
        :check-values="pharmacyTagCheckList"
        :on-change-check-values="onChangePharmacyTagCheck"
      ></pharmacy-tag-component>
    </div>
    <div class="flex">
      <div class="flex-row mr-2">
        <button type="button" @click="updatePharmacyMedicineTag" class="w-full py-2.5 px-5 mr-2 my-2 text-sm font-medium text-white focus:outline-none bg-amber-500 rounded-full border border-gray-200 hover:bg-amber-300 hover:text-black focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700">登録する</button>
      </div>
      <div class="flex-row mr-2">
        <button type="button" @click="closePharmacyMedicineTagDialog" class="w-full py-2.5 px-5 mr-2 my-2 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-full border border-gray-200 hover:text-black focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700">キャンセル</button>
      </div>
    </div>
  </template>
</modal-dialog>

</template>

